// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#call_button[data-v-d5f2dc04]{margin:0 auto}`, "",{"version":3,"sources":["webpack://./src/components/TopBar/CallButton.vue"],"names":[],"mappings":"AACA,8BACC,aAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
